module.exports = __webpack_public_path__ + "img/media_set.54d63153.png";